import listActions from 'src/modules/dataLake/list/dataLakeListActions';
import DataLakeService from 'src/modules/dataLake/dataLakeService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'DATALAKE_DESTROY';

const dataLakeDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: dataLakeDestroyActions.DESTROY_STARTED,
      });

      await DataLakeService.destroyAll([id]);

      dispatch({
        type: dataLakeDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.dataLake.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/data-lake');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: dataLakeDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: dataLakeDestroyActions.DESTROY_ALL_STARTED,
      });

      await DataLakeService.destroyAll(ids);

      dispatch({
        type: dataLakeDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.dataLake.destroyAll.success'),
      );

      getHistory().push('/data-lake');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: dataLakeDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default dataLakeDestroyActions;
